module.exports = __webpack_public_path__ + "static/homepage-8ce1902f8731ea00e320530e9307a83b.mp4";